module.exports = __webpack_public_path__ + "img/64.c76ebfe5.webp";